module.exports = __webpack_public_path__ + "static/img-24-9c8c871411b1fda025e436bae5fc5725.jpeg";